// extracted by mini-css-extract-plugin
export default {"tag":"RoleTag_tag__k3YTa","admin":"RoleTag_admin__768WX","manager":"RoleTag_manager__vve-8","member":"RoleTag_member__HCYPa","default":"RoleTag_default__w9Eje"};